export default "__VITE_ASSET__DpPGtCRF__"